import { useState } from "react";
import "../../../assets/styles/ProductStyles/AddProductStyles/Addproduct.css";
import StatusDropdown from "./SubComponents/Component/Select_Component/StatusDropdown";
import Product_Details from "./SubComponents/Product_Details_Component/Product_Details";
import Product_Owner_details from "./SubComponents/Product_Owner_details.jsx/Product_Owner_details";
import Add_Product_Button from "./SubComponents/Component/Add_Product_Button/Add_Product_Button";

const AddProduct = ({ id, ProductId }) => {
  const [activeTab, setActiveTab] = useState("details");

  return (
    <div className="border-2 w-[80vw] border-gray-200 rounded-2xl p-5">
      <div className="border-b flex justify-between items-center pb-2">
        <div className="font-semibold w-full text-gray-600 text-xl">
          Add Product
        </div>
        {activeTab === "owner" && (
          <div className="w-full">
            <Add_Product_Button />
          </div>
        )}
      </div>

      <div className="flex flex-col">
        {/* Tab Navigation */}
        <div className="flex items-center justify-between text-lg font-semibold gap-4 mt-4">
          <div className="flex items-center gap-4">
            <button
              onClick={() => setActiveTab("details")}
              className={
                activeTab === "details"
                  ? "text-[#FF0000] font-semibold underline decoration-[#FF0000] underline-offset-4"
                  : "text-gray-500 hover:text-[#FF0000]"
              }
            >
              Product Details
            </button>
            <button
              onClick={() => setActiveTab("owner")}
              className={
                activeTab === "owner"
                  ? "text-[#FF0000] font-semibold underline decoration-[#FF0000] underline-offset-4"
                  : "text-gray-500 hover:text-[#FF0000]"
              }
            >
              Product Owner Details
            </button>
          </div>

          <div>
            <StatusDropdown />
          </div>
        </div>

        {/* Tab Content */}
        <div className="mt-6 ">
          {activeTab === "details" && (
            <Product_Details setActiveTab={setActiveTab} />
          )}
          {activeTab === "owner" && (
            <div className="w-full">
              <Product_Owner_details />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AddProduct
